import DetailAccentCard, {
	DetailSectionHeading,
} from "../../../common/detail/DetailAccentCard";

export default function ContentSection({ publication }) {
	if (!publication?.text) {
		return null;
	}

	return (
		<DetailAccentCard
			ariaLabel="متن مقاله"
			className="w-full min-w-0 max-w-full"
			bodyClassName="p-5 md:p-8"
		>
			<DetailSectionHeading className="mb-4">متن مقاله</DetailSectionHeading>
			<article
				className="publication-content text-right font-Vazir-400 text-[15px] leading-[1.9] text-darkBlue/90"
				dangerouslySetInnerHTML={{ __html: publication.text }}
			/>
		</DetailAccentCard>
	);
}
